import { MilestoneUpdateType } from 'types'

const checkIfAllowedClearDate = (updateType?: MilestoneUpdateType) =>
  updateType === MilestoneUpdateType.MANUAL

export const LotUtils = {
  checkIfAllowedClearDate,
}
